// extracted by mini-css-extract-plugin
export default {"root":"_3Dr1W","left":"_3FiYz","left-side-item-wrapper":"_14dsi","leftSideItemWrapper":"_14dsi","right":"_3cdjE","right-side-item-wrapper":"_3E-nL","rightSideItemWrapper":"_3E-nL"};